import { Route, Routes } from 'react-router';
import SettingsPage from '../pages/SettingsPage';
import CheckpointSettingsPage from '../pages/CheckpointSettingsPage';

const SettingsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<SettingsPage />} />
      <Route path="checkpoints" element={<CheckpointSettingsPage />} />
    </Routes>
  );
};

export default SettingsRoutes;
